// Фокус после перехода (задача D5, ui-spec §6): открылся другой экран — фокус на его заголовок `h1`, чтение с экрана
// называет экран, а Tab идёт дальше по нему, а не с начала меню. При первой загрузке фокус не трогаем: человек
// ещё ничего не нажимал. Параметры адреса (`?check=…`, фильтры) — не переход: фокус остаётся где был.
//
// Заголовок экрана — `h1[tabindex="-1"]` (PageShell и экраны-состояния D4); на узком экране он стоит в верхней полосе
// и в документе идёт первым.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

/** Заголовок экрана, на который встаёт фокус. */
export const PAGE_TITLE_SELECTOR = 'h1[tabindex="-1"]';

export function RouteFocus() {
  const { pathname } = useLocation();
  // Прошлый путь, а не флаг «первый раз»: в StrictMode эффект при монтировании идёт дважды, и флаг сбросился бы.
  const previous = useRef<string | null>(null);
  useEffect(() => {
    const before = previous.current;
    previous.current = pathname;
    if (before === null || before === pathname) return;
    document.querySelector<HTMLElement>(PAGE_TITLE_SELECTOR)?.focus();
  }, [pathname]);
  return null;
}
